module.exports = __webpack_public_path__ + "media/images/ic-meajude-menu-b39729a69312a97ca5a38fea57f7ab41.svg";